/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response light for get financial group
 * @export
 * @interface FinancialGroupLightResponse
 */
export interface FinancialGroupLightResponse {
    /**
     * Unique identifier of the financial group
     * @type {number}
     * @memberof FinancialGroupLightResponse
     */
    id?: number;
    /**
     * The financial group code
     * @type {string}
     * @memberof FinancialGroupLightResponse
     */
    code?: string;
    /**
     * The financial group name
     * @type {string}
     * @memberof FinancialGroupLightResponse
     */
    title?: string;
    /**
     * Indicate if the financial group is active
     * @type {boolean}
     * @memberof FinancialGroupLightResponse
     */
    active?: boolean;
    /**
     * Unique identifier of the financial group owner
     * @type {string}
     * @memberof FinancialGroupLightResponse
     */
    owner?: string;
    /**
     * The misa number of a common financial group
     * @type {string}
     * @memberof FinancialGroupLightResponse
     */
    misaNumber?: string;
    /**
     * The personal info appearing on the bill
     * @type {string}
     * @memberof FinancialGroupLightResponse
     */
    personalInfo?: string;
}

/**
 * Check if a given object implements the FinancialGroupLightResponse interface.
 */
export function instanceOfFinancialGroupLightResponse(value: object): value is FinancialGroupLightResponse {
    return true;
}

export function FinancialGroupLightResponseFromJSON(json: any): FinancialGroupLightResponse {
    return FinancialGroupLightResponseFromJSONTyped(json, false);
}

export function FinancialGroupLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialGroupLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'title': json['title'] == null ? undefined : json['title'],
        'active': json['active'] == null ? undefined : json['active'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'misaNumber': json['misaNumber'] == null ? undefined : json['misaNumber'],
        'personalInfo': json['personalInfo'] == null ? undefined : json['personalInfo'],
    };
}

export function FinancialGroupLightResponseToJSON(json: any): FinancialGroupLightResponse {
    return FinancialGroupLightResponseToJSONTyped(json, false);
}

export function FinancialGroupLightResponseToJSONTyped(value?: FinancialGroupLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'title': value['title'],
        'active': value['active'],
        'owner': value['owner'],
        'misaNumber': value['misaNumber'],
        'personalInfo': value['personalInfo'],
    };
}

